module.exports = __webpack_public_path__ + "img/car_shina2_04.e53bdbe8.jpg";